// import { Sort, SortDirection } from '../models/sort';
import { AssignmentData } from '../model/assignmentdata';
import { Sort } from '../model/sort';

export class PrepareListData {
    static columnNames: any = { month: 'Month', 
        weekNo: 'Week No',
        empName: 'Name', 
        day: 'Day', 
        projNo: 'Project No', 
        projName: 'Project Name', 
        taskNo: 'Task No', 
        taskName: 'Task Name', 
        expType: 'Exp. Type', 
        hours: 'Hours' };

        public static curData:AssignmentData[] = [];

    static getDisplayWeek(weekNo: string): string {
        return `${weekNo.slice(0, 4)}-${weekNo.slice(4, 6)}`;
    }


    static async sort(dataSource: AssignmentData[], sort: Sort, sortField: string): Promise<AssignmentData[]> {
        if (dataSource.length === 0) return [];
        return await this.sortData( dataSource, sort, sortField )
    }


    static async sortData(dataSource: AssignmentData[], sort: Sort, sortField: string): Promise<AssignmentData[]> {
        if ( sort.direction === "asc" ) {
            sortField = sort.active;
            return this.sortDataAsc( dataSource, sortField );
        } else if ( sort.direction === "desc" ) {
            sortField = sort.active;
            return this.sortDataDesc( dataSource, sortField );
        } else {
            return this.sortDataDesc( dataSource, sortField );
        }
        //return (dataSource);;
    }

    static async sortDataDesc(tmpData: AssignmentData[], sortField: string): Promise<AssignmentData[]> {
        tmpData.sort( function (a: any,b: any) { return ( b[sortField] > a[sortField] ) ? 1 : -1; } );
        return tmpData;
    }

    static async sortDataAsc(tmpData: AssignmentData[], sortField: string):  Promise<AssignmentData[]> {
        tmpData.sort( function (a: any,b: any) { return ( a[sortField] <= b[sortField] ) ? -1 : 1; } );
        return tmpData;
    }

    static prepareData(data: AssignmentData[], sortField: string): Promise<AssignmentData[]> {
        let tmpData: AssignmentData[] = [];
        data.forEach( x => {
            tmpData.push(new AssignmentData(x));
        })
        data = tmpData; 

        var sort: Sort = {
            active: sortField,
            direction: 'asc'
        };
        
        return this.sort(tmpData, sort, sort.active);
    }
}